import { withImageOptimizationQuery } from '@common/utils';
import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useStoreDealGuideBannerService = () => {
  const params = useCatalogProductIdParams();
  const {
    product: { store_deal_banner, store_deal_guide_banner_url },
  } = usePdpBaseInfo(params);

  return {
    guidance_image_url:
      withImageOptimizationQuery(store_deal_guide_banner_url, { format: 'webp', quality: 80 }) ??
      store_deal_guide_banner_url ??
      '',
    is_hide: !store_deal_banner,
  };
};
